import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToId } from "../../lib/api";

const CHAPTERS = [
  { id: "services", n: "01", label: "Diagnose" },
  { id: "process", n: "02", label: "Process" },
  { id: "clients", n: "03", label: "Fit" },
  { id: "predictor", n: "04", label: "Forecast" },
  { id: "pricing", n: "05", label: "Recovery" },
  { id: "contact", n: "06", label: "Begin" },
];

export default function ChapterRail() {
  const [active, setActive] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: "-40% 0px -55% 0px" }
    );
    CHAPTERS.forEach((c) => {
      const el = document.getElementById(c.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <div
      data-testid="chapter-rail"
      className="hidden xl:flex fixed top-1/2 right-6 -translate-y-1/2 z-40 flex-col gap-4"
      aria-label="Chapter navigation"
    >
      {CHAPTERS.map((c) => {
        const isActive = active === c.id;
        return (
          <button
            key={c.id}
            data-testid={`rail-${c.id}`}
            onClick={() => scrollToId(c.id)}
            className="group relative flex items-center gap-3 justify-end"
            aria-label={`Jump to ${c.label}`}
          >
            {/* Label — reveals on hover */}
            <motion.span
              initial={false}
              animate={{ opacity: isActive ? 1 : 0, x: isActive ? 0 : 4 }}
              className={`text-[10px] uppercase tracking-[0.3em] whitespace-nowrap group-hover:opacity-100 group-hover:translate-x-0 ${isActive ? "text-[#1e3d3a]" : "text-[#1e3d3a]/60"}`}
            >
              <span className="text-[#c9a961] font-medium">Ch. {c.n}</span>
              <span className="mx-1.5 text-[#1e3d3a]/25">·</span>
              {c.label}
            </motion.span>
            {/* Dot */}
            <motion.span
              initial={false}
              animate={{
                width: isActive ? 24 : 8,
                backgroundColor: isActive ? "#c9a961" : "rgba(30,61,58,0.25)",
              }}
              transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
              className="h-[2px] rounded-full group-hover:!bg-[#c9a961]"
            />
          </button>
        );
      })}
    </div>
  );
}
